module.exports = __webpack_public_path__ + "img/yeosu_gallery3.cd7702cd.jpg";